module.exports = __webpack_public_path__ + "static/media/chr-busd.302aacd1.svg";